import arrowRight from "../../../assets/general/carbon_arrow-right.svg";

interface UserTypeCardData {
  title: string;
  description: string;
}

interface UserTypeCardProps {
  card: UserTypeCardData;
}

export function UserTypeCard({ card }: UserTypeCardProps) {
  return (
    <div className="item">
      <div className="section-masthead__heading">
        <h3 className="h3 mt-0 mb-0">{card.title}</h3>
      </div>
      <img src={arrowRight} alt="->" />
      <div className="section-masthead__heading">
        <p>{card.description}</p>
      </div>
    </div>
  );
}

export type { UserTypeCardData };
